// import { Link } from "react-router-dom"

// const Missing = () => {
//     return (
//         <article style={{ padding: "100px" }}>
//             <h1>Oops!</h1>
//             <p>Page Not Found</p>
//             <div className="flexGrow">
//                 <Link to="/">Visit Our Homepage</Link>
//             </div>
//         </article>
//     )
// }

// export default Missing



import { Link } from "react-router-dom";

const Missing = () => {
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#c0edd8",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  };

  const contentStyle = {
    textAlign: "center",
    padding: "40px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    maxWidth: "500px",
    width: "100%",
  };

  const headingStyle = {
    fontSize: "72px",
    color: "#dc3545",
    marginBottom: "10px",
    fontWeight: "bold",
  };

  const subheadingStyle = {
    fontSize: "24px",
    color: "#333333",
    marginBottom: "20px",
  };

  const paragraphStyle = {
    fontSize: "16px",
    color: "#666666",
    marginBottom: "30px",
  };

  const linkStyle = {
    display: "inline-block",
    padding: "12px 24px",
    backgroundColor: "#007bff",
    color: "#ffffff",
    textDecoration: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    transition: "background-color 0.3s ease",
  };

  const hoverLinkStyle = {
    ...linkStyle,
    backgroundColor: "#0056b3",
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <div style={headingStyle}>404</div>
        <div style={subheadingStyle}>Oops! Page Not Found</div>
        <div style={paragraphStyle}>
          The page you're looking for doesn't exist or has been moved.
        </div>
        <Link
          to="/"
          style={linkStyle}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          Go to Homepage
        </Link>
      </div>
    </div>
  );
};

export default Missing;
